import {HTTPError, HTTPCodesEnum} from '@jetbrains/teamcity-ui/dist/services'
import type {KeyValue} from '@jetbrains/teamcity-ui/dist/utils'
import type {GraphQLResponseWithData, PayloadError} from 'relay-runtime'

const ERROR_STATUSES_MAP: KeyValue<string, HTTPCodesEnum> = {
  NOT_FOUND: HTTPCodesEnum.NOT_FOUND,
  ACCESS_DENIED: HTTPCodesEnum.FORBIDDEN,
  SERVER_ERROR: HTTPCodesEnum.INTERNAL_SERVER_ERROR,
  OPERATION_FAILED: HTTPCodesEnum.BAD_REQUEST,
}

type PayloadErrorWithExtensions = PayloadError & {
  extensions?:
    | {
        classification: string
        [key: string]: string
      }
    | undefined
}

export function processGraphQLErrors(response: GraphQLResponseWithData) {
  if (response.errors != null) {
    const error = response.errors[0] as PayloadErrorWithExtensions

    if (
      error?.extensions?.classification != null &&
      ERROR_STATUSES_MAP[error.extensions.classification] != null
    ) {
      throw new HTTPError(error.message, ERROR_STATUSES_MAP[error.extensions.classification])
    }

    throw new HTTPError(error.message, HTTPCodesEnum.OK)
  }
}
